import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './CaseCreateScreen';
import CaseCreate from './CaseCreateScreen';
import { StoreState } from 'src/store/reducers';
import { formValueSelector, getFormValues, change } from 'redux-form';
import CaseEnum from 'src/enumerables/case-enum';

import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';
import { getOrdersFully } from 'src/store/actions/order-actions';
import { QueryParams } from 'src/types/grid';
import { getServiceTypes } from 'src/store/actions/service-type-actions';
import { getServiceLocations } from 'src/store/actions/service-location-actions';
import { getProvidersSmall } from 'src/store/actions/provider-actions';
import { getStudentsSmall } from 'src/store/actions/student-actions';
import { getDistrictsSmall } from 'src/store/actions/district-actions';
import { getVendorsSmall } from 'src/store/actions/vendor-actions';
import { selectNameStudents } from '../../../../../../store/selectors/students-selectors';
import { selectNameDistricts } from '../../../../../../store/selectors/districts-selectors';
import { selectNameVendors } from '../../../../../../store/selectors/vendors-selectors';
import OrderEnum from '../../../../../../enumerables/order-enum';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    const selector = formValueSelector('case-form');
    const caseType = selector(state, 'caseTypeDropDown');
    const invoiceSigner = selector(state, 'invoiceSignerDropDown');
    const statusItem = selector(state, 'caseStatusDropdown');
    const caseEnum = CaseEnum ? CaseEnum.getEnum('caseType') : {};
    const caseTypes: SelectObject[] = getValFromEnum(caseEnum);

    const serviceTypeProviderEnum = OrderEnum ? OrderEnum.getEnum('ServiceTypeProvider') : {};
    const serviceTypeProviders: SelectObject[] = getValFromEnum(serviceTypeProviderEnum);

    const caseTypeValue: string | number = caseType ? caseType.value : undefined;
    const invoiceSignerValue: string | number = invoiceSigner ? invoiceSigner.value : undefined;

    const orderType = selector(state, 'orderTypeDropDown');
    const typeEnum = CaseEnum ? CaseEnum.getEnum(`OrderType_${caseTypeValue}`) : {};
    const orderTypes: SelectObject[] = getValFromEnum(typeEnum);

    const serviceTypeProvider = selector(state, 'serviceTypeProviderDropDown');
    const serviceTypeProviderValue: string | number = serviceTypeProvider ? serviceTypeProvider.value : undefined;

    const statusEnum = CaseEnum ? CaseEnum.getEnum('CaseStatus') : {};
    const statusItems: SelectObject[] = getValFromEnum(statusEnum);

    const statusItemValue: string | number = statusItem ? statusItem.value : statusItems ? statusItems[0].value : 1;

    const orderTypeValue: string | number = orderType ? orderType.value : undefined;

    const orders = selector(state, 'ordersDropDown');
    const orderValue = orders ? orders.value : undefined;

    //console.log(serviceTypeProviderValue, serviceTypeProvider);

    return {
        inProgress: state.cases.inProgress,
        inProgressVendors: state.vendors.inProgress,
        inProgressDistrict: state.districts.inProgress,
        inProgressStudent: state.students.inProgress,
        orders: state.orders.data,
        serviceLocations: state.serviceLocations.data,
        providers: state.providers.data,
        inProgressProvider: state.providers.inProgress,
        students: selectNameStudents(state),
        districts: selectNameDistricts(state),
        vendors: selectNameVendors(state),
        serviceTypes: state.serviceTypes.data,
        serviceTypeProviderValue,
        orderValue,
        caseTypeValue,
        invoiceSignerValue,
        orderTypes,
        caseTypes,
        serviceTypeProviders,
        orderTypeValue,
        statusItemValue,
        valuesForm: getFormValues('case-form')(state),
        //dataFormOrders,
        isDouble: state.cases.isDouble,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getOrders: (params: QueryParams) => dispatch(getOrdersFully(params)),
        getServiceTypes: (params: QueryParams) => dispatch(getServiceTypes(params)),
        getServiceLocations: (params: QueryParams) => dispatch(getServiceLocations(params)),
        getProviders: (params: QueryParams) => dispatch(getProvidersSmall(params)),
        getStudents: (params: QueryParams) => dispatch(getStudentsSmall(params)),
        getVendors: (params: QueryParams) => dispatch(getVendorsSmall(params)),
        getDistricts: (params: QueryParams) => dispatch(getDistrictsSmall(params)),
        changeValue: (field: string, value: string | null) => {
            dispatch(change('case-form', field, value));
        },
    };
}

const CaseCreateScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(CaseCreate);

export default CaseCreateScreen;
